export default "__VITE_ASSET__732c1785__"